import React, { Component } from 'react'
import ReactTable from 'react-table-6'
import { connect } from 'react-redux'
import {
  dashboardFetchRequested,
  narrativeHistoryFetchRequested,
  narrativeHistoryReset,
  transitionCompleted,
  transitionProposed,
} from '../actions/narrative'
import 'react-table-6/react-table.css'
import Modal from 'react-modal'
import { Button } from '@wfp/ui'
import DraftDocuments from './DraftDocuments'
import { TRANSITION_SUCCEEDED } from '../constants'
import ConfirmationModal from './ConfirmationModal'
import ReactExport from 'react-export-excel'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

class Dashboard extends Component {
  componentDidMount() {
    this.props.dashboardFetchRequested()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.transitionStatus === TRANSITION_SUCCEEDED) {
      // When we get notice that the "create" transition succeeded, redirect to the editors
      this.props.transitionCompleted()
      this.props.history.push({
        pathname: `/edit/${nextProps.narrative.id}/`,
      })
    }
  }

  filterFn = accessor => ({ filter, onChange }) => {
    let found = {}
    let options = this.props.dashboard
      .filter(function(row) {
        if (row[accessor] && !found[row[accessor]]) {
          found[row[accessor]] = true
          return true
        }
        return false
      })
      .sort((a, b) => (a[accessor] > b[accessor] ? 1 : b[accessor] > a[accessor] ? -1 : 0))
      .map(function(row) {
        return (
          <option value={row[accessor]} key={row[accessor]}>
            {row[accessor]}
          </option>
        )
      })
    return (
      <select
        onChange={event => {
          onChange(event.target.value)
        }}
        style={{ width: '100%' }}
        value={filter ? filter.value : 'all'}>
        <option value='all' key={'all'}>
          All
        </option>
        {options}
      </select>
    )
  }
  filterMethod = (filter, row, column) => {
    if (filter.value === 'all') {
      return true
    }
    const id = filter.pivotId || filter.id
    return row[id] !== undefined ? String(row[id]) === String(filter.value) : true
  }

  iconCell = row => {
    const img =
      row.value === 'Working' ? 'timer' : row.value === 'Done' ? 'tick' : row.value === 'Skipped' ? 'cross' : false
    const staticRootUrl = window.djconfig ? window.djconfig.STATIC_URL : '/'
    if (row.value) {
      return (
        <div
          style={{
            width: '100%',
            height: '100%',
            // backgroundSize: '35px',
            background: `url("${staticRootUrl}images/${img}.png") no-repeat center top`,
          }}
          title={row.value}
        />
      )
    } else {
      return <div />
    }
  }

  columns = [
    {
      Header: 'RB',
      accessor: 'regional_bureau',
      Filter: this.filterFn('regional_bureau'),
      filterMethod: this.filterMethod,
    },
    {
      Header: 'Country',
      accessor: 'country_name',
      Filter: this.filterFn('country_name'),
      filterMethod: this.filterMethod,
    },
    {
      Header: 'CSP Code',
      accessor: 'csp_country_key',
      Filter: this.filterFn('csp_country_key'),
      filterMethod: this.filterMethod,
    },
    {
      Header: 'Start Year',
      accessor: 'start_year',
      Filter: this.filterFn('start_year'),
      filterMethod: this.filterMethod,
    },
    { Header: 'End Year', accessor: 'end_year', Filter: this.filterFn('end_year'), filterMethod: this.filterMethod },
    {
      Header: 'COMP Year',
      accessor: 'reporting_year',
      Filter: this.filterFn('reporting_year'),
      filterMethod: this.filterMethod,
    },
    { Header: 'Version', accessor: 'version', Filter: this.filterFn('version'), filterMethod: this.filterMethod },
    {
      Header: 'Type',
      accessor: 'type',
      Filter: this.filterFn('type'),
      filterMethod: this.filterMethod,
    },
    {
      Header: 'CO Draft',
      accessor: 'co_draft',
      Cell: this.iconCell,
      Filter: this.filterFn('co_draft'),
      filterMethod: this.filterMethod,
    },
    {
      Header: 'CO Review',
      accessor: 'co_review',
      Cell: this.iconCell,
      Filter: this.filterFn('co_review'),
      filterMethod: this.filterMethod,
    },
    {
      Header: 'RB Review',
      accessor: 'rb_review',
      Cell: this.iconCell,
      Filter: this.filterFn('rb_review'),
      filterMethod: this.filterMethod,
    },
    {
      Header: 'HQ Review',
      accessor: 'hq_review',
      Cell: this.iconCell,
      Filter: this.filterFn('hq_review'),
      filterMethod: this.filterMethod,
    },
    {
      Header: 'HQ Published',
      accessor: 'hq_published',
      Cell: this.iconCell,
      Filter: this.filterFn('hq_published'),
      filterMethod: this.filterMethod,
    },
  ]

  render() {
    const d = new Date()
    const currentDateLocalTz = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toJSON().slice(0, 10)
    return (
      <div>
        {this.props.dashboard.length > 0 && (
          <div style={{ textAlign: 'left', margin: '36px' }}>
            <ReactTable
              data={this.props.dashboard}
              columns={this.columns}
              showPagination={false}
              defaultPageSize={this.props.dashboard.length}
              loading={this.props.dashboardLoading}
              minRows={0}
              sortable={true}
              resizable={false}
              filterable={true}
              className='-striped -highlight'
              defaultSorted={[
                {
                  id: 'country_name',
                  desc: false,
                },
                {
                  id: 'csp_country_key',
                  desc: false,
                },
                {
                  id: 'reporting_year',
                  desc: false,
                },
                {
                  id: 'version',
                  desc: false,
                },
              ]}
              defaultFiltered={[
                {
                  id: 'reporting_year',
                  value: new Date().getFullYear(),
                },
              ]}
              getTrProps={(state, rowInfo, column) => {
                return {
                  onClick: (event, handleOriginal) => {
                    if (rowInfo.row.version) {
                      this.props.narrativeHistoryFetchRequested(rowInfo.row.csp_country_key, rowInfo.row.reporting_year)
                    } else if (['CO', 'HQ'].includes(this.props.role)) {
                      this.props.transitionProposed(
                        {
                          csp_country_key: rowInfo.row.csp_country_key,
                          year: rowInfo.row.reporting_year,
                        },
                        'initialize'
                      )
                    }
                  },
                  'data-testid': `row${rowInfo.index}`,
                }
              }}
            />
            <ExcelFile
              filename={`COMP Narratives Dashboard ${currentDateLocalTz}`}
              element={<Button style={{ margin: '15px' }}>Export to Excel</Button>}>
              <ExcelSheet data={this.props.dashboard} name={`COMP Narratives ${currentDateLocalTz}`}>
                <ExcelColumn label='Regional Bureau' value='regional_bureau' />
                <ExcelColumn label='Country' value='country_name' />
                <ExcelColumn label='CSP Code' value='csp_country_key' />
                <ExcelColumn label='Start Year' value='start_year' />
                <ExcelColumn label='End Year' value='end_year' />
                <ExcelColumn label='COMP Year' value='reporting_year' />
                <ExcelColumn label='Version' value='version' />
                <ExcelColumn label='Type' value='type' />
                <ExcelColumn label='CO Draft' value='co_draft' />
                <ExcelColumn label='CO Review' value='co_review' />
                <ExcelColumn label='RB Review' value='rb_review' />
                <ExcelColumn label='HQ Review' value='hq_review' />
                <ExcelColumn label='HQ Published' value='hq_published' />
              </ExcelSheet>
            </ExcelFile>
          </div>
        )}
        {this.props.narrativeHistory.length > 0 && (
          <Modal ariaHideApp={false} isOpen={true} onRequestClose={this.closeModal} contentLabel='Example Modal'>
            <div>
              <DraftDocuments narratives={this.props.narrativeHistory} history={this.props.history} />
              <Button onClick={() => this.props.narrativeHistoryReset()} className='close-button'>
                Close this window
              </Button>
            </div>
          </Modal>
        )}
        <ConfirmationModal history={this.props.history} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dashboard: state.narrative.dashboard,
  dashboardLoading: state.narrative.dashboardLoading,
  narrativeHistory: state.narrative.narrativeHistory,
  narrativeHistoryLoading: state.narrative.narrativeHistoryLoading,
  transitionStatus: state.narrative.transitionStatus,
  narrative: state.narrative.narrative,
  role: state.appSettings.userInfo && state.appSettings.userInfo.role,
})

const mapDispatchToProps = {
  dashboardFetchRequested,
  narrativeHistoryFetchRequested,
  narrativeHistoryReset,
  transitionProposed,
  transitionCompleted,
}

Dashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard)

export default Dashboard
